import { Button } from "@mui/material";
import { Col, Row, message } from "antd";
import { useState } from 'react';
import { updatePrinterEvent } from "../../../_events/print/create.event";

export default function PrinterConfig({ printers, loadPrinters }){
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    return(
        <div style={{ flexDirection: 'column'}}>

            <Button
                style={{ marginBottom: '15px' }}
                variant="contained"
                size="small"
                onClick={toggleAccordion}
            >
                Conexión impresoras
            </Button>

            {isAccordionOpen && (
                <div style={{ display: 'flex', flexDirection: 'row', margin: '20px 0px' }}>
                    <Row>
                    {
                        printers.map( (p, key) => (
                            
                                <Col key={`printers_${key}`} lg={24} xs={24}>
                                    <div style={{ display:'flex', flexDirection: 'row' }}>
                                        <div style={{ margin: '10px 10px' }}>
                                            <span>{p.name}</span>
                                        </div>
                                        <div style={{ margin: '10px 10px' }}>
                                            <input 
                                                id={`${p.id}`}
                                                defaultValue={p.ip}
                                            />
                                        </div>
                                        <div style={{ margin: '10px 10px' }}>
                                            <Button size="small" variant="contained"
                                                onClick={() => {
                                                    updatePrinterEvent(
                                                        {
                                                            id: p.id,
                                                            ip: document.getElementById(`${p.id}`).value,
                                                        }
                                                    )
                                                    .then(json => {
                                                        message.success('Actualizado');
                                                        loadPrinters();
                                                    })
                                                    .catch(err => {
                                                        message.error(err.message);
                                                    });
                                                }}
                                            >
                                                Actualizar
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            
                        ))
                    }
                    </Row>      
                </div>
            )}
        </div>
    );
   
}
